import api from '@pray/shared/utils/api';

// Hard-deletes a Pray Radio daily item (soft-delete server-side, destroyed=1)
// AND removes its episode from the podcast host. Distinct from unschedulePrayRadioDaily,
// which clears scheduled_at and keeps the item, so it can be scheduled again.
export async function deletePrayRadioDailyItem({
  artistId,
  dailySeriesId,
  dailyItemId,
}: {
  artistId: string;
  dailySeriesId: string;
  dailyItemId: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
